









import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    isHidden: {
      type: Boolean,
    },
    selected: {
      type: Boolean,
    },
    untitled: {
      type: Boolean,
    },
  },
  setup(_, { listeners }) {
    return { listeners };
  },
});
